import { Overlay, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from 'js-cookie';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useRef, useState } from "react";
import { setLoggedInUser } from "../../../redux/slices/logged_in_user";
import { setAuthorization } from "../../../services/axios_client";
import { LOGGED_IN_USER, TOKEN_NAME } from "../../../utils/constants";
import default_avatar from '../../../assets/images/default_avatar.webp';

export default function HeaderComponent() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const loggedInUser = useSelector(state => state.loggedInUser?.user);
  const pageTitle = useSelector(state => state.header?.pageTitle);

  const logout = () => {
    Cookies.remove(TOKEN_NAME);
    Cookies.remove(LOGGED_IN_USER);
    setAuthorization('');
    dispatch(setLoggedInUser(null));
    navigate('/login', { replace: true, state: { path: location.pathname } });
  }

  return (
    <header className="d-flex justify-content-between align-items-center bg-light shadow-sm" style={{ height: 40 }}>
      <div className="h5 mb-0 border-start border-4 ps-2 border-dark py-2 fw-bold">{pageTitle}</div>
      {
        loggedInUser && (
          <>
            <div className="d-flex align-items-center gap-1 cursor-pointer pe-3" ref={target} onClick={() => setShow(!show)}>
              <div>
                <img src={default_avatar} className="rounded-circle border object-fit-cover" style={{ width: 30, height: 30 }} alt="avatar" />
              </div>
              <div className="small">{loggedInUser.fullname}</div>
            </div>
            <Overlay
              target={target.current}
              show={show}
              placement="bottom"
              rootClose={true}
              onHide={() => setShow(false)}
            >
              {(props) => (
                <Tooltip {...props} className="bg-light">
                  <div className="p-1">
                    <div>
                      <Link className="text-white text-decoration-none d-flex align-items-center" to='/profile' onClick={() => setShow(false)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                          <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                        </svg>
                        <span className="ms-1">Thông tin</span>
                      </Link>
                    </div>
                    <div className="mt-2">
                      <button
                        className="btn btn-link text-white text-decoration-none d-flex align-items-center p-0"
                        onClick={(e) => {
                          e.preventDefault();
                          setShow(false);
                          logout();
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-box-arrow-left" viewBox="0 0 16 16">
                          <path fillRule="evenodd" d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0z" />
                          <path fillRule="evenodd" d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708z" />
                        </svg>
                        <span className="ms-1">Đăng xuất</span>
                      </button>
                    </div>
                  </div>
                </Tooltip>
              )}
            </Overlay>
          </>
        )
      }
    </header>
  )
}